import { Backdrop, CircularProgress } from '@mui/material'
import React from 'react'

const Loader = ({open}) => {
    return (
        <Backdrop
            sx={(theme) => ({ color: '#fff', zIndex:99999 })}
            open={open}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    )
}

export default Loader